import React, { Component } from "react";
import { Button, Box, Divider, Paper, Menu } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { messages as learningPathMessagesPath } from "../../../routes/LearningCenterRoutes";
import { messages as adminConsoleMessagesPath } from "../../../routes/AdminRoutes";
import { learningCenterRoot, adminConsoleRoot } from "../../../routes/Routes";
import MessagesList from "../../DashboardWidgets/Messages/MessagesList";

const styles = theme => ({
  popper: {
    zIndex: 1200
  }
});

const useMessagesStyles = makeStyles(theme => ({
  divider: {
    width: "100%"
  },
  paper: {
    maxWidth: 440,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%"
    }
  }
}));

const Messages = ({ messages, onViewAllMessagesClick }) => {
  const classes = useMessagesStyles();
  const { t } = useTranslation();
  return (
    <Paper className={classes.paper}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        py={3}
        px={4}
      >
        <Box maxHeight={352} overflow="scroll">
          <MessagesList messages={messages} />
        </Box>
        <Divider className={classes.divider} />
        <Box mt={3}>
          <Button
            data-qa="top-nav-messages-btn"
            variant="text"
            color="primary"
            onClick={onViewAllMessagesClick}
          >
            {t("learningCenterTopNav.topNavMessages.topNavMessagesButton")}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

class TopNavMessages extends Component {
  onViewAllMessagesClick = () => {
    const { history, onLeaveMessages } = this.props;
    onLeaveMessages();
    if (history.location.pathname.indexOf(adminConsoleRoot) === 0) {
      history.push(adminConsoleMessagesPath);
    }
    if (history.location.pathname.indexOf(learningCenterRoot) === 0) {
      history.push(learningPathMessagesPath);
    }
  };

  render() {
    const {
      messagesMenuAnchor,
      messages,
      messagesExpanded,
      onLeaveMessages
    } = this.props;

    return (
      <Menu
        transformOrigin={{ vertical: -14, horizontal: "center" }}
        open={messagesExpanded}
        anchorEl={messagesMenuAnchor}
        onClose={onLeaveMessages}
      >
        <Messages
          messages={messages}
          onViewAllMessagesClick={this.onViewAllMessagesClick}
        />
      </Menu>
    );
  }
}

const TranslatedTopNavMessages = withTranslation()(
  withStyles(styles)(TopNavMessages)
);

export default withRouter(TranslatedTopNavMessages);

TopNavMessages.propTypes = {
  messagesMenuAnchor: PropTypes.any,
  messages: PropTypes.arrayOf(PropTypes.any),
  /**
   * True if the messages are expanded
   */
  messagesExpanded: PropTypes.bool,
  /**
   * Called when the user clicks outside of the Messages Popper
   */
  setMessagesExpanded: PropTypes.func,
  /**
   * Called when the user hovers outside of the messages Popper
   */
  onLeaveMessages: PropTypes.func
};
